/**
 * Modify the CSS of a DOM.
 * @param dom
 * @param css
 * @returns
 */
export function modifyCSS(dom, css) {
    if (!dom)
        return;
    Object.keys(css).forEach(function (key) {
        dom.style[key] = css[key];
    });
    return dom;
}
//# sourceMappingURL=modify-css.js.map